import common from '../common';

export default class Logger {
	constructor() {
		throw new Error('This is a static class');
	}

	static log(...args) {
		if (!common.debug) return;
		// eslint-disable-next-line no-console
		console.log(...args);
	}

	static warn(...args) {
		console.warn(...args);
	}

	static error(...args) {
		console.error(...args);
	}
}
